var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.0805 4.29945C1.67497 6.61779 2.88149 8.73381 4.57384 10.4262C6.26619 12.1185 8.38221 13.325 10.7006 13.9195C12.4844 14.3736 14 12.8397 14 10.9983V10.1651C14 9.70521 13.6259 9.3361 13.1685 9.29028C12.4099 9.21487 11.6653 9.03573 10.9555 8.75787L9.68906 10.0243C7.62701 9.03581 5.96419 7.37299 4.97568 5.31094L6.24213 4.04449C5.96398 3.3347 5.78456 2.5901 5.70889 1.83153C5.6639 1.37327 5.29479 1 4.83487 1H4.00167C2.16032 1 0.626405 2.51558 1.0805 4.29945Z",
    stroke: "#EE3224",
    strokeWidth: 0.833194,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/Call.1743ae55ffd22bb9a5ad49e49230d206.svg";
export { ForwardRef as ReactComponent };